import Card from 'react-bootstrap/Card'

import styles from './index.module.scss'

const RelatedCard = ({ children, className, ...props }) => (
  <Card body className={`mb-4 ${styles.card} ${className}`} {...props}>
    {children}
  </Card>
)

export default RelatedCard
